import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

const PrivacyText = styled.span`
  ${props => props.theme?.privacyLabel?.standard};
  ${props => _.get(props, ['theme', 'privacyLabel', props.page])}
  a {
    ${props => props.theme?.privacyLabel?.standard}
    ${props => _.get(props, ['theme', 'privacyLabel', props.page])}
  }
`;

export default function PrivacyLabel({text, page}) {
  return <PrivacyText page={page}>{text}</PrivacyText>;
}
